import { useState, useEffect } from 'react';
import DeviationMediaService from '../DeviationMediaService';
export function useHeroImage(deviation, width, height) {
    var _a = useState({
        hero: deviation && DeviationMediaService.getSmallestThumb(deviation),
        loaded: false,
    }), hero = _a[0], setHero = _a[1];
    useEffect(function () {
        if (!deviation) {
            setHero({ hero: undefined, loaded: true });
            return;
        }
        var bestFitImage = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, width, height, function (t) { return t[t.length - 1]; }, // Take largest if nothing covers,
        { allowFullview: true, allowPreview: true });
        if (bestFitImage) {
            var img = new Image();
            img.onload = function () { return setHero({ hero: bestFitImage, loaded: true }); };
            img.src = bestFitImage.src;
        }
    }, [deviation, height, width]);
    return hero;
}
//# sourceMappingURL=useHeroImage.js.map